import { Button, IconButton, Modal } from '@mui/material';
import React, { useEffect, useState } from 'react'
import CloseIcon from '@mui/icons-material/Close';
import styled from 'styled-components';
import API from '../../../../api/axios';
import { APP_URLS } from '../../../../api/url';
import { toast } from 'react-toastify';
import { APIError } from '../../../../core/utils';


const ViewSummary = () => {

    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const [isLoading, _isLoading] = useState(false)
    const [jsonData, _jsonData] = useState({})

    useEffect(() => {
        (() => {
            _isLoading(true);

            API.get(`${APP_URLS.VAT_AUDIT_LOGS}/statistics`)
                .then((res) => {
                    const resp = res.data;
                    if (resp.success === true) {
                        _jsonData(resp.data)
                    } else {
                        toast.error(resp.message, { position: toast.POSITION.TOP_RIGHT });
                    }
                })
                .catch((error) => {
                    let error_message = APIError(error);
                    toast.error(error_message, { position: toast.POSITION.TOP_RIGHT });
                })
                .finally(() => {
                    _isLoading(false);
                });
        })()
    }, [])

    return (
        <>
            <Button onClick={handleOpen} variant="outlined" disabled={isLoading} className="extract-report" style={{ minWidth: 'max-content' }}>
                View summary
            </Button>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Wrapper>
                    <Header>
                        <h3>Summary</h3>
                        <IconButton onClick={handleClose} size="small">
                            <CloseIcon />
                        </IconButton>
                    </Header>
                    <Content>
                        <pre>{jsonData ? JSON.stringify(jsonData, null, 2) : null}</pre>
                    </Content>
                </Wrapper>
            </Modal>
        </>
    )
}

export default ViewSummary

const Wrapper = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100vw;
    max-width: 50vw;
    max-height: 80vh;
    background: #FFFFFF;
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
`;

const Header = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 20px;
    border-bottom: 1px solid #e0e0e0;

    h3 {
        margin: 0;
        font-size: 18px;
        font-weight: 600;
    }
`;

const Content = styled.div`
    padding: 16px 20px;
    overflow-y: auto;
    flex: 1;

    pre {
        background: #f8f9fa;
        padding: 12px;
        border-radius: 6px;
        font-size: 14px;
        line-height: 1.4;
        white-space: pre-wrap;
        word-wrap: break-word;
    }
`;